import { render } from "./priceRangeSlider.vue?vue&type=template&id=297a266c"
import script from "./priceRangeSlider.vue?vue&type=script&lang=js"
export * from "./priceRangeSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__